export const TAX_FREE = "taxfree"
export const SHOPS = "shops"
export const DINERS = "diners"
export const BOTH = "both"
